import { cn, Tooltip } from '@heroui/react'
import { Button } from 'components/ui/Button'
import { Check, Copy } from 'lucide-react'
import { useCallback, useState } from 'react'

export default function CopyButton({ value, displayText, className, tooltip, ...props }) {
  const [copied, setCopied] = useState(false)

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(value)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }, [value])

  return (
    <Tooltip content={tooltip} isDisabled={!tooltip}>
      <Button
        variant="ghost"
        onClick={handleCopy}
        className={cn(className)}
        {...props}
      >
        {displayText}
        {copied
          ? <Check className="h-3.5 w-3.5" />
          : (
              <Copy className="h-3.5 w-3.5" />
            )}
      </Button>
    </Tooltip>
  )
}
